import { StackedHorizontalBarChart } from '@sanlam-glacier/app-common/components';
import styles from '../exposure-breakdown-takeover.module.scss';
import {
  Reg28ActualAssetClassExposureMaxLimitsResponseModelMock,
  Reg28ActualAssetClassExposureWeightsResponseModelMock
} from '../../../../types/regulation-28/regulation-28.interfaces';

const labels = [
  'Equity %',
  'Property %',
  'Bonds %',
  'Cash %',
  'Hedge %',
  'Private equity %',
  'Commodities %',
  'Other %'
];

type ActualAssetClassExposureChartProps = {
  chartData?: Reg28ActualAssetClassExposureWeightsResponseModelMock;
  maxLimits?: Reg28ActualAssetClassExposureMaxLimitsResponseModelMock;
};

export const Reg28ActualAssetClassExposureChart = ({
  chartData,
  maxLimits
}: ActualAssetClassExposureChartProps) => {
  const data = [
    chartData?.equity ?? 0,
    chartData?.property ?? 0,
    chartData?.bonds ?? 0,
    chartData?.cash ?? 0,
    chartData?.hedge ?? 0,
    chartData?.privateEquity ?? 0,
    chartData?.commodities ?? 0,
    chartData?.other ?? 0
  ];

  const maximums = [
    maxLimits?.equity ?? 0,
    maxLimits?.property ?? 0,
    maxLimits?.bonds ?? 0,
    maxLimits?.cash ?? 0,
    maxLimits?.hedge ?? 0,
    maxLimits?.privateEquity ?? 0,
    maxLimits?.commodities ?? 0,
    maxLimits?.other ?? 0
  ];

  return (
    <div className={styles.assetClassExposureChart}>
      <StackedHorizontalBarChart
        labels={labels}
        values={data}
        title='Weighted allocation'
        backgroundBar={{
          label: '% Allowed (Maximum)',
          values: maximums
        }}
        diffsBar={{
          label: 'Over allocation'
        }}
        options={{
          tooltipSuffix: '%',
          min: 0,
          max: 100,
          step: 10
        }}
      />
    </div>
  );
};
